<template>
  <div class="main clearfix">
    <top-menu :isCollapse.sync="isCollapse" v-if="isLeftMenu" :menuArr="showRouter"></top-menu>
    <left-munu :isCollapse="isCollapse" v-if="isLeftMenu && showRouter.length>1" :menuArr="showRouter"></left-munu>
    <div class="main-content" :class="{'margin-left': isLeftMenu && showRouter.length>1, 'min': isCollapse && showRouter.length }">
      <div>
        <keep-alive >
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- <router-view /> -->
      </div>
    </div>
  </div>
</template>
<script>
const leftMunu = () => import("@/view/common/leftMenu.vue");
const topMenu = () => import("@/view/common/topMenu.vue");
import { mapMutations } from "vuex";
export default {
  name: "mainBody",
  data() {
    return {
      isCollapse: false
    };
  },
  computed: {
    allRouter() {
      return this.$router.options.routes;
    },
    currentRouter() {
      return this.$route;
    },
    isLeftMenu() {
      return this.currentRouter.name != "login" || this.currentRouter.name !="cockpit";
    },
    showRouter() {
      // console.log(this.currentRouter,this.$router.options.routes,22222222222222)
      let currentMeta = this.currentRouter ? this.currentRouter.meta || {} : {};
      let _thisRouter = this.allRouter.filter(e => e.name && e.name == currentMeta.menuKey)[0] || {}
      console.log(_thisRouter.children,11111111111)
      return _thisRouter.children || []
    }
  },
  components: {
    leftMunu,
    topMenu
  },
  methods: {
    ...mapMutations(["setBucketDomain"]),
    init() {
      // this.getUrlDomain();
    }
  },
  created() {
    this.init();
  },
  mounted(){}
};
</script>
<style lang="less" scoped>
.main {
  position: relative;
  .main-content {
    transition: 0.5s all;
    margin-left: 0;
  }
  .margin-left {
    margin-left: 262px;
    &.min {
      margin-left: 64px;
    }
  }
}

.pages{
  padding:30px
}
</style>
